import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { Location } from "@angular/common";
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
import { BidService } from "../../../services/bids.service";
import { BidRound, BidRoundData } from "../../../interfaces/responses/models";
import { TransactionComponent } from "../../../interfaces/transaction-component";
import { BidRoundService } from "../../../services/bid-round.service";
import { HttpErrorResponse } from "@angular/common/http";
import {
  BidRoundStatus,
  BidStatus,
  TransactionType,
  ErrorCodeEnum,
} from "../../../interfaces/enums";
import { MAX_DATE_DIFFERENCE, MILLISECONDS_IN_DAY } from "src/constants";
import { formatDate } from "@angular/common";
import { DateTime } from "luxon";
import { LocalStorageService } from "../../../services/local-storage.service";
import { ScreenSizeService } from "../../../services/screen-size.service";
import { positiveNumberValidator } from "../../../shared/validators/positive-number-validator";
import { UserService } from "src/app/services/user.service";
import { MatDialog } from "@angular/material/dialog";
import { WebPaymentModelComponent } from "../web-payment-model/web-payment-model.component";
import { switchMap, finalize } from "rxjs/operators";
import { of } from "rxjs";
import { PaymentService } from "src/app/services/payment/user-wallet.service";
import { PaymentTransactionService } from "src/app/services/payment/payment-transaction.service";
import { timer, Subscription } from "rxjs";

@Component({
  selector: "app-bidding",
  templateUrl: "./bidding.component.html",
  styleUrls: ["./bidding.component.css"],
})
export class BiddingComponent implements OnInit {
  transactionType: TransactionType = TransactionType.Buy;
  offer: string = "";
  color: string = "";
  BiddingForm: FormGroup;
  bids: any[] = [];
  error: string | null = null;
  acceptedBids: any[] = [];
  openBids: any[] = [];
  closedBids: any[] = [];
  bidRounds: BidRound[] = [];
  activeBids: any[] = [];
  filteredBidRoundData: BidRoundData[] = [];
  activeBid: any | null = null;
  errorMessage: string = "";
  minDate: string = "";
  minAfterDate: string = "";
  isLoading: boolean = false;
  userName: string = "";
  loadingMessage: string = "";
  private balancePollSub?: Subscription;

  isMobile: boolean = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private location: Location,
    private bidRoundService: BidRoundService,
    private bidService: BidService,
    private localStorageService: LocalStorageService,
    private screenSizeService: ScreenSizeService,
    private userService: UserService,
    private paymentService: PaymentService,
    private paymentTxService: PaymentTransactionService,
    private dialog: MatDialog
  ) {
    this.BiddingForm = this.fb.group({
      bidCategory: ["", Validators.required],
      bidRound: ["", this.validateRequirementOnNotCustomRange()],
      numberOfUnits: ["", [Validators.required, positiveNumberValidator()]],
      bidRate: ["", [Validators.required, positiveNumberValidator()]],
      customerId: [
        "",
        [Validators.min(0.1), this.validateRequirementOnCustomRange()],
      ],
      startDate: ["", [this.validateRequirementOnCustomRange()]],
      endDate: ["", [this.validateRequirementOnCustomRange()]],
    });
  }

  ngOnInit(): void {
    this.screenSizeService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
    this.activatedRoute.data.subscribe((data) => {
      const transactionData = data as TransactionComponent;
      this.transactionType = transactionData.transactionType as TransactionType;
      this.offer = transactionData.offer;
    });
    this.getBidRounds();
    this.createMinDate();
    this.createMinAfterDate();
    this.BiddingForm.get("startDate")?.setValue(this.minDate);
    this.BiddingForm.get("endDate")?.setValue(this.minAfterDate);
    this.BiddingForm.get("bidCategory")!.valueChanges.subscribe((category) => {
      this.updateValidatorsOnChange();
      this.filterBidRoundData(category);
      this.BiddingForm.get("bidRound")?.reset(null);
    });
    const st = history.state;
    if (st.paymentResult === "success" && st.formData) {
      // this.waitForWalletThenSubmit({
      //   formData: st.formData,
      //   bidPrice: st.bidPrice,
      //   energyAmount: st.energyAmount,
      //   transactionType: st.transactionType,
      //   customerId: st.customerId,
      // });
       this.placeBidNow(
           st.formData,
       st.bidPrice,
         st.energyAmount,
       st.transactionType,
   st.customerId,
          );
    }
  }

  updateValidatorsOnChange(): void {
    const bidRoundControl = this.BiddingForm.get("bidRound");
    const bidCustomerIdControl = this.BiddingForm.get("customerId");
    const startDateControl = this.BiddingForm.get("startDate");
    const endDateControl = this.BiddingForm.get("endDate");

    if (this.isCustomRangeSelected()) {
      bidRoundControl?.clearValidators();
      bidCustomerIdControl?.setValidators([
        Validators.min(1),
        Validators.required,
      ]);
      startDateControl?.setValidators([Validators.required]);
      endDateControl?.setValidators([Validators.required]);
    } else {
      bidRoundControl?.setValidators([Validators.required]);
      bidCustomerIdControl?.clearValidators();
      startDateControl?.clearValidators();
      endDateControl?.clearValidators();
    }

    bidRoundControl?.updateValueAndValidity();
    bidCustomerIdControl?.updateValueAndValidity();
    startDateControl?.updateValueAndValidity();
    endDateControl?.updateValueAndValidity();
  }

  onCustomerIdBlur() {
    const customerId = this.BiddingForm.get("customerId")?.value;
    if (!customerId) {
      console.log("Customer ID is empty");
      return;
    }

    this.userService.getUserName(customerId).subscribe(
      (response) => {
        this.userName = response.name;
        console.log("User Name Response:", response);
      },
      (error) => {
        this.userName = "";
        console.error("Error fetching user name:", error);
      }
    );
  }

  private nextDate(increase: number): string {
    const now = DateTime.local()
      .setZone("Asia/Kolkata")
      .plus({ days: increase });
    return now.toFormat("yyyy-MM-dd");
  }

  private createMinDate(): void {
    this.minDate = this.nextDate(1);
  }
  private createMinAfterDate(): void {
    this.minAfterDate = this.nextDate(2);
  }

  validateRequirementOnNotCustomRange(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const isRequired = !value && !this.isCustomRangeSelected();
      return isRequired ? { required: true } : null;
    };
  }

  validateRequirementOnCustomRange(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const isRequired = !value && this.isCustomRangeSelected();
      return isRequired ? { required: true } : null;
    };
  }

  validateDateRange(): string | null {
    // Only validate a number if the selected bid bidCategory is a custom range
    if (!this.isCustomRangeSelected()) return null;

    const startDateValue = Date.parse(
      this.BiddingForm?.get("startDate")?.value
    );
    const endDateValue = Date.parse(this.BiddingForm?.get("endDate")?.value);
    if (Number.isNaN(startDateValue) || Number.isNaN(endDateValue))
      return "Start and end date are required";

    const startDate = new Date(startDateValue);
    const endDate = new Date(endDateValue);
    if (!startDate || !endDate) return "Start and end date are required";
    if (startDate >= endDate) return "End date must be after start date";

    const differenceInTime = endDate.getTime() - startDate.getTime();
    const differenceInDays = differenceInTime / MILLISECONDS_IN_DAY;
    if (differenceInDays > MAX_DATE_DIFFERENCE)
      return `Date range must be less than ${MAX_DATE_DIFFERENCE} days`;
    if (differenceInDays < 1)
      return "There must be at least 1 day difference between start and end days";
    return null;
  }

  isCustomRangeSelected(): boolean {
    return (
      this.BiddingForm?.value?.bidCategory === "Preferential Exchange of Energy"
    );
  }
  navigateTo(path: string, extras?: NavigationExtras | undefined) {
    this.router.navigate([path], extras);
  }

  goBack() {
    this.location.back();
  }

  /**
   * @brief Formats the date into a valid string format for the fixed rate request.
   * Assumes that date is a valid date string
   */
  formatDateForRequest(date: string): string {
    return formatDate(date, "YYYY-MM-dd 00:00", "en_US");
  }

  get number_of_units() {
    return this.BiddingForm.get("numberOfUnits");
  }
  get bid_rate() {
    return this.BiddingForm.get("bidRate");
  }

  // onSubmit() {
  //   this.isLoading = true;
  //   const validateDateRangeError = this.validateDateRange();
  //   if (validateDateRangeError) {
  //     this.errorMessage = validateDateRangeError;
  //     this.isLoading = false;
  //     return;
  //   }
  //   if (this.BiddingForm.invalid) {
  //     this.errorMessage = "Form is invalid";
  //     this.isLoading = false;
  //     return;
  //   }
  //   this.errorMessage = "";
  //   // Extract out the values and convert to appropriate type
  //   const formData = this.BiddingForm.value;
  //   console.log(formData);
  //   const transactionType =
  //     this.transactionType === TransactionType.Buy ? 1 : 2; // buy or sell
  //   const bidPrice = parseFloat(formData.bidRate);
  //   const energyAmount = parseFloat(formData.numberOfUnits);
  //   const customerId = parseInt(formData.customerId);

  //   if (this.isCustomRangeSelected()) {
  //     const fixedRateBidData = {
  //       price: bidPrice,
  //       start_date: this.formatDateForRequest(formData.startDate),
  //       end_date: this.formatDateForRequest(formData.endDate),
  //       energy_amount: energyAmount,
  //       bid_type: transactionType,
  //       customer_id: customerId,
  //     };
  //     console.log(fixedRateBidData);
  //     this.bidService.createFixRateBid(fixedRateBidData).subscribe(
  //       (response) => {
  //         const ownBidId = response.own_bid.id;
  //         const navigationExtras: NavigationExtras = {
  //           state: { bidData: response },
  //         };
  //         this.localStorageService.setFixRateBid(response);
  //         console.log(navigationExtras);
  //         console.log("creating fixed rate bid");
  //         this.isLoading = false;
  //         this.navigateTo(`fixed-rate-bid/${ownBidId}`, navigationExtras);
  //       },
  //       (error: HttpErrorResponse) => {
  //         console.error(error);
  //         this.isLoading = false;
  //         const errorDetail = error.error.detail.toString();
  //         const role = this.localStorageService.getRole();
  //         if (
  //           errorDetail.includes(ErrorCodeEnum.FIXED_RATE_BID_SAME_USER_TYPES)
  //         ) {
  //           this.errorMessage = `You cannot place a bid with another ${role}.`;
  //         } else {
  //           this.errorMessage = errorDetail;
  //         }
  //       }
  //     );
  //     return;
  //   }

  //   const bidData = {
  //     bid_price: bidPrice,
  //     transaction_type_id: transactionType,
  //     energy_amount: energyAmount,
  //     bid_round_id: formData.bidRound,
  //   };

  //   this.bidService.createBid(bidData).subscribe(
  //     (response) => {
  //       if (
  //         response.status === BidStatus.Active ||
  //         response.status === BidStatus.Pending
  //       ) {
  //         this.isLoading = false;
  //         this.errorMessage = "";

  //         if (response.id) {
  //           this.navigateTo(`strike/${response.id}`);
  //         } else {
  //           this.navigateTo("strike");
  //         }
  //       }
  //     },
  //     (error: HttpErrorResponse) => {
  //       console.log(error);
  //       this.handleBidError(error);
  //       this.isLoading = false;
  //     }
  //   );
  // }

  // … inside your BiddingComponent class …

  private placeBidNow(
    formData: any,
    bidPrice: number,
    energyAmount: number,
    transactionType: number,
    customerId: number
  ) {
    const isFixedRate =
      formData.bidCategory === "Preferential Exchange of Energy";

    if (isFixedRate) {
      // use the dates from formData
      const fixedRateBidData = {
        price: bidPrice,
        start_date: this.formatDateForRequest(formData.startDate),
        end_date: this.formatDateForRequest(formData.endDate),
        energy_amount: energyAmount,
        bid_type: transactionType,
        customer_id: customerId,
      };
      this.bidService.createFixRateBid(fixedRateBidData).subscribe(
        (res) => {
          const ownBidId = res.own_bid.id;
          this.localStorageService.setFixRateBid(res);
          this.isLoading = false;
          this.navigateTo(`fixed-rate-bid/${ownBidId}`, {
            state: { bidData: res },
          });
        },
        (err) => {
          this.isLoading = false;
          this.errorMessage =
            err?.error?.detail || "Failed to create fixed‑rate bid.";
        }
      );
    } else {
      const bidData = {
        bid_price: bidPrice,
        transaction_type_id: transactionType,
        energy_amount: energyAmount,
        bid_round_id: formData.bidRound,
      };
      this.bidService.createBid(bidData).subscribe(
        (res) => {
          this.isLoading = false;
          this.navigateTo(res.id ? `strike/${res.id}` : "strike");
        },
        (err) => {
          this.isLoading = false;
          this.errorMessage = err?.error?.detail || "Failed to create bid.";
        }
      );
    }
  }

  private waitForWalletThenSubmit(ctx: {
    formData: any;
    bidPrice: number;
    energyAmount: number;
    transactionType: number;
    customerId: number;
  }) {
    this.loadingMessage = "Verifying payment...";
    this.isLoading = true;

    this.balancePollSub = timer(0, 4000) // every 4 s
      .pipe(
        switchMap(() =>
          this.paymentService.validateBalance({
            bid_price: ctx.bidPrice,
            energy_amount: ctx.energyAmount,
            transaction_type_id: ctx.transactionType,
          })
        )
      )
      .subscribe((res) => {
        const required = parseFloat(res.required_balance);
        if (required <= 0) {
          this.balancePollSub?.unsubscribe(); // stop polling
          this.loadingMessage = "Placing your bid...";
          this.placeBidNow(
            ctx.formData,
            ctx.bidPrice,
            ctx.energyAmount,
            ctx.transactionType,
            ctx.customerId
          );
        }
      });
  }

  private checkBalance(
    bidPrice: number,
    energyAmount: number,
    transactionType: number,
    customerId: number,
    formData: any
  ) {
    this.loadingMessage = "Checking wallet balance...";
    this.paymentService
      .validateBalance({
        bid_price: bidPrice,
        energy_amount: energyAmount,
        transaction_type_id: transactionType,
      })
      .pipe(
        switchMap((res) => {
          console.log(res);
          const required = parseFloat(res.required_balance);
          if (required <= 0) {
            return of(null); // skip top‑up
          }
          this.loadingMessage = "Creating payment intent...";
          return this.paymentService.addTokens({
            amount: required,
            payment_method: "icici_cbdc",
            device: "web",
          });
        })
      )
      .subscribe({
        next: (resp) => {
          if (resp === null) {
            this.loadingMessage = "Placing your bid...";
            this.placeBidNow(
              formData,
              bidPrice,
              energyAmount,
              transactionType,
              customerId
            );
          } else {
            // B) got intent → redirect to payment page
            this.loadingMessage = "Redirecting to payment...";

            // SAVE TO SESSION STORAGE
            const bidContext = {
              qr_code: resp.qr_code,
              intentLink: resp.payment_intent.intent_link,
              txId: resp.payment_intent.transaction_id,
              amount: resp.payment_intent.amount,
              message: resp.payment_intent.message,
              returnRoute:
                this.transactionType === TransactionType.Buy ? "/buy" : "/sell",
              formData,
              bidPrice,
              energyAmount,
              transactionType,
              customerId,
            };
            sessionStorage.setItem(
              "pendingBidContext",
              JSON.stringify(bidContext)
            );

            this.router.navigate(["/payment"], {
              state: bidContext, // Still pass state for the initial navigation
            });
          }
        },
        error: (err) => {
          console.error("validateBalance error", err);
          this.isLoading = false;
          this.loadingMessage = "";
          if (err.error && err.error.message) {
            this.errorMessage = err.error.message;
          }
          else if (typeof err.error === "string") {
            this.errorMessage = err.error;
          }
          else {
            this.errorMessage = err.message || "An unknown error occurred";
          }
        },
      });
  }

  //
  onSubmit(): void {
    this.isLoading = true;
    this.loadingMessage = "Validating form...";
    this.errorMessage = "";

    const formData = this.BiddingForm.value;
    const bidPrice = parseFloat(formData.bidRate);
    const energyAmount = parseFloat(formData.numberOfUnits);
    const customerId = parseInt(formData.customerId, 10);
    const transactionType =
      this.transactionType === TransactionType.Buy ? 1 : 2;

    if (this.isCustomRangeSelected()) {
      const startDate = formData.startDate;
      const endDate = formData.endDate;
      this.bidService
        .validatePreferentialBid(
          customerId,
          startDate,
          endDate,
          energyAmount,
          bidPrice
        )
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe({
          next: (response: string) => {
            console.log("Validation succeeded:", response);
            this.checkBalance(
              bidPrice,
              energyAmount,
              transactionType,
              customerId,
              formData
            );
          },
          error: (err: any) => {
            console.error("validateBalance error", err);
          this.isLoading = false;
          this.loadingMessage = "";
          if (err.error && err.error.message) {
            this.errorMessage = err.error.message;
          }
          else if (typeof err.error === "string") {
            this.errorMessage = err.error;
          }
          else {
            this.errorMessage = err.message || "An unknown error occurred";
          }
          },
        });
    } else {
      const bidRoundId = formData.bidRound;
      const bid_type = formData.bidCategory
      
      this.bidService
        .validateNonPreferentialBid(bidRoundId, transactionType, bidPrice,bid_type)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe({
          next: (response: string) => {
            console.log("Validation succeeded:", response);
            this.checkBalance(
              bidPrice,
              energyAmount,
              transactionType,
              customerId,
              formData
            );
          },
          error: (err: any) => {
             console.error("validateBalance error", err);
          this.isLoading = false;
          this.loadingMessage = "";
          if (err.error && err.error.message) {
            this.errorMessage = err.error.message;
          }
          else if (typeof err.error === "string") {
            this.errorMessage = err.error;
          }
          else {
            this.errorMessage = err.message || "An unknown error occurred";
          }
          },
        });
    }
  }

  loadBids(): void {
    const filter = { limit: 1 };
    this.bidService.getFilteredBids(filter).subscribe(
      (data) => {
        if (Array.isArray(data.items)) {
          this.bids = data.items;
          let sortedItems = data.items.sort((a: any, b: any) => {
            return (
              new Date(b.created_on).getTime() -
              new Date(a.created_on).getTime()
            );
          });
          this.activeBid = sortedItems[0];
          if (sortedItems.length == 0) {
            return;
          }
        } else {
          console.error("Data is not an array:", data);
          this.error = "Unexpected data format received from server";
        }
      },
      (error) => {
        console.error("Error loading bids:", error);
        this.error = "Error loading bids: " + error.message;
      }
    );
  }
  handleBidError(error: any): void {
    const errorCode = error?.error?.code;
    switch (errorCode) {
      case ErrorCodeEnum.INVALID_BID_ID:
        this.errorMessage = "Invalid Bid ID. Please try again.";
        break;
      case ErrorCodeEnum.BID_ROUND_NOT_OPEN:
        this.errorMessage =
          "The bid round is not open. Please try again later.";
        break;
      case ErrorCodeEnum.USER_ALREADY_PLACED_BID:
        this.errorMessage = "You have already placed a bid in this round.";
        break;
      case ErrorCodeEnum.INVALID_BID_PRICE:
        this.errorMessage = "Invalid bid price. Please enter a valid amount.";
        break;
      case ErrorCodeEnum.BLOCK_CHAIN_ERROR:
        this.errorMessage =
          "The transaction failed due to a blockchain, smart contract, or network saturation issue. Please try again later.";
        break;
      case ErrorCodeEnum.PENDING_TRANSACTION_ERROR:
        this.errorMessage =
          "User has pending transactions, wait until all transactions are confirmed.";
        "The transaction failed due to a blockchain, smart contract, or network saturation issue. Please try again later.";
        break;
      default:
        if (errorCode === ErrorCodeEnum.BLOCK_CHAIN_ERROR) {
          this.errorMessage =
            "The transaction failed due to a blockchain, smart contract, or network saturation issue. Please try again later.";
        } else {
          this.errorMessage = error.error.detail;
        }
        break;
    }
  }
  onBidCategoryChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedType = selectElement.value;
    this.updateValidatorsOnChange();
    this.filterBidRoundData(selectedType);
    this.BiddingForm.get("bidRound")?.reset(null);
  }

  filterBidRoundData(selectedType: string) {
    const selectedBidRound = this.bidRounds.find(
      (round) => round.type === selectedType
    );
    if (selectedBidRound) {
      this.filteredBidRoundData = selectedBidRound.bid_round_data
        .filter((br) => br.status === BidRoundStatus.Open)
        .sort(
          (a, b) =>
            new Date(a.start_trade_period).getTime() -
            new Date(b.start_trade_period).getTime()
        )
        .map((data: BidRoundData) => data);
    } else {
      this.filteredBidRoundData = [];
    }
  }

  getBidRounds() {
    this.bidRoundService.getBidRounds().subscribe(
      (data: BidRound[]) => {
        console.log(data[0].bid_round_data);

        this.bidRounds = [];
        data.forEach((item: BidRound) => {
          if (item.type === "Fix rate") {
            this.bidRounds.push({
              type: "Preferential Exchange of Energy",
              bid_round_data: [],
            });
          }
        });

        data.forEach((item: BidRound) => {
          if (item.type === "Day ahead") {
            this.bidRounds.push({
              type: "Day ahead",
              bid_round_data: item.bid_round_data,
            });
          } else if (item.type === "Monthly") {
            this.bidRounds.push({
              type: "Monthly",
              bid_round_data: item.bid_round_data,
            });
          }
        });

        console.log("Bid rounds:", this.bidRounds);
      },
      (error) => {
        console.error("Error loading bid rounds:", error);
        this.error = "Error loading bid rounds: " + error.message;
      }
    );
  }
}
